import { Box, TextField, IconButton } from '@mui/material'
import { Send, Stop } from '@mui/icons-material'

const ChatInput = ({ value, onChange, onSend, onCancel, isLoading }) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      if (value.trim() && !isLoading) onSend()
    }
  }

  return (
    <Box sx={{ p: 2, borderTop: 1, borderColor: 'divider', display: 'flex', gap: 1, alignItems: 'flex-end' }}>
      <TextField
        fullWidth
        size="small"
        multiline
        maxRows={4}
        placeholder="Digite sua pergunta..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={isLoading}
      />
      {isLoading ? (
        <IconButton color="error" onClick={onCancel} size="small">
          <Stop />
        </IconButton>
      ) : (
        <IconButton color="primary" onClick={onSend} disabled={!value.trim()} size="small">
          <Send />
        </IconButton>
      )}
    </Box>
  )
}

export default ChatInput
